import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Tooltip,
  tooltipClasses,
  Typography,
  Paper,
  TextField,
  Autocomplete,
} from "@mui/material";
import CommonButton from "../../../../../components/CustomComponents/Buttons/CommonButton.js";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styled from "styled-components/macro";
import Collapsible from "../../../../../components/CustomComponents/Collapsible.js";
import DatePickerComponent from "../../../../../components/CustomComponents/DateRangePicker/RangePicker.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "dayjs";
import { useStyles } from "../../../../../components/Models/FilterModelEmotionAI/style.js";
import AddIcon from "@mui/icons-material/Add";

import { languagesData } from "../../../../../assets/defaultLanguage/index.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate } from "react-router-dom";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    placement="top-start"
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#1B2430",
    borderRadius: "8px",
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  height: "30px",
  padding: "6px",
  paddingRight: "15px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  borderRadius: "800px",
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.typography.body2,
}));

const SmallCheckbox = styled(Checkbox)({
  // padding: "0px 12px 0px 0px",
  width: "12px",
  height: "12px",
  "& .MuiSvgIcon-root": {
    fontSize: "16px", // Adjust the size of the icon inside the checkbox
  },
});

const FilterModal = ({
  handleCloseModalFilter,
  openModalFilter,
  resetHandler,
  handleChangeStartDate,
  handleChangeEndDate,
  sentimentValue,
  startDate,
  endDate,
  allLocations,
  locations,
  setLocations,
  setLanguage,
  language,
  allGroups,
  selectedGroups,
  setSlectedGroups,

  countries,
  nextEndDate,
  nextStartDate,
  compareRange,
  dateRangeTimePeriod,
  setDateRangeTimePeriod,
  endDateRangeSchedule,
  startDateRangeSchedule,
  defaultLocation,
  handleDateRangChange,
  setScheduleSentiments,
  locationAddPermission,
  locationViewPermission,
  autoSelectHeader,
  isSentimentalAnalysisDone,
  selectAll,
  selectAllLocations,
  setSelectAllLocations,
  setAutoSelect,
  autoSelect,
  selectAllGroups,
  setSelectAllGroups,
  selectAllFeatures,
  setSelectAllFeatures,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorBulk, setAnchorBulk] = useState(null);
  const [isSorted, setIsSorted] = useState("");
  const [expandedPanels, setExpandedPanels] = useState([]);
  const [checkedLocation, setCheckedLocation] = useState(false);
  const [section, setSection] = useState("locations");
  const [dateRange, setDateRange] = React.useState({
    startDate: new Date(startDateRangeSchedule),
    endDate: new Date(endDateRangeSchedule),
  });
  const [modellocations, setModelLocations] = useState(locations);
  const [startDateModel, setStartDateModel] = useState(startDate);
  const [endDateModel, setEndDateModel] = useState(endDate);
  const [nextStartDateModel, setNextStartDateModel] = useState(nextStartDate);
  const [nextEndDateModel, setnextEndDateModel] = useState(nextEndDate);
  const [selectedGroupsModel, setSelectedGroupsModel] =
    useState(selectedGroups);
  const [sentimentValueModel, setSentimentValueModel] =
    React.useState(sentimentValue);
  const [languageModel, setLanguageModel] = useState(language);
  const [oldGroupsModel, setOldGroupsModel] = useState([]);
  const [rangeModel, setRangeModel] = useState(dateRangeTimePeriod);
  const [loading, setLoading] = useState(false);
  const [expandAllPanels, setExpandAllPanels] = useState(true);
  const [startDateRangeScheduleModel, setStartDateRangeScheduleModel] =
    useState(startDateRangeSchedule);
  const [endDateRangeScheduleModel, setEndDateRangeScheduleModel] =
    useState(endDateRangeSchedule);

  const sentimentsValues = [
    {
      label: `${t("positive")}`,
      value: "Positive",
    },
    {
      label: `${t("negative")}`,
      value: "Negative",
    },
    {
      label: `${t("neutral")}`,
      value: "Neutral",
    },
  ];

  const timePeriod = [
    { id: 0, name: "All", value: "All" },
    { id: 1, name: "today", value: "Today" },
    { id: 2, name: "yesterday", value: "Yesterday" },
    { id: 3, name: "2days", value: "2days" },
    { id: 4, name: "7days", value: "7days" },
    { id: 5, name: "week", value: "week" },
    { id: 6, name: "14days", value: "14days" },
    { id: 7, name: "30days", value: "30days" },
    { id: 8, name: "monthValue", value: "month" },
    { id: 9, name: "60days", value: "60days" },
    { id: 10, name: "90days", value: "90days" },
    { id: 11, name: "6months", value: "6months" },
    { id: 12, name: "12months", value: "12months" },
    { id: 12, name: "custom_text", value: "custom" },
  ];

  useEffect(() => {
    if (openModalFilter) {
      setModelLocations(locations);
    }
  }, [openModalFilter]);
  useEffect(() => {
    if (selectAllGroups) {
      handleExpandPanel(undefined, true, "groups");
    }
  }, [selectAllGroups]);

  /*  useEffect(() => {
    if (startDateModel !== null && endDateModel !== null) {
      let startDateOnee = dayjs(startDateModel);
      const startDateOne = startDateOnee.subtract(1, "days");
      const endDateOne = dayjs(endDateModel);
      // const endDateOne = endDateOnee.subtract(1, "days");
      const today = dayjs();

      if (
        (rangeModel !== null && rangeModel?.value === "gt") ||
        (compareRange !== null && compareRange?.value === "gt")
      ) {
        const difference = startDateOnee.diff(today);

        const diffInMonths = monthDiff(startDateOnee, today);

        if (diffInMonths === 12 || diffInMonths > 12) {
          const newStartDate = startDateOne.subtract(1, "year");
          setNextStartDateModel(newStartDate.toDate());
        } else {
          const diffInDays = today.diff(startDateOnee, "days");

          if (diffInMonths < 12 || diffInDays < 30) {
            if (diffInMonths === 0 && diffInDays < 30) {
              const newStartDate = startDateOne.subtract(diffInDays, "days");
              setNextStartDateModel(newStartDate.toDate());
            } else {
              const newStartDate = startDateOne.subtract(
                diffInMonths,
                "months"
              );
              setNextStartDateModel(newStartDate.toDate());
            }
          }
        }

        setnextEndDateModel(startDateOnee.toDate());
      } else if (
        (rangeModel !== null && rangeModel?.value === "lt") ||
        (compareRange !== null && compareRange?.value === "lt")
      ) {
        const diff = monthDiff(endDateOne, today);

        if (diff === 12 || diff > 12) {
          const newEndDate = endDateOne.add(1, "year");
          setnextEndDateModel(newEndDate.toDate());
        } else {
          setnextEndDateModel(today.toDate());
        }

        setNextStartDateModel(endDateOne.toDate());
      } else {
        const diffInMonths = monthDiff(startDateOnee, endDateOne);
        const diffInDays = endDateOne.diff(startDateOnee, "days");
        if (diffInMonths < 12 || diffInDays > 0) {
          if (diffInDays > 0) {
            const newStartDate = startDateOne.subtract(diffInDays, "days");
            setNextStartDateModel(newStartDate.toDate());
            setnextEndDateModel(startDateOne.endOf("day").toDate());
          } else {
            const newStartDate = startDateOne.subtract(diffInMonths, "months");

            setNextStartDateModel(newStartDate.toDate());
            setnextEndDateModel(startDateOnee.toDate());
          }
        } else {
          const yearsToSubtract = Math.floor(diffInMonths / 12);
          const remainingMonths = diffInMonths % 12;

          const newStartDate = startDateOne
            .subtract(yearsToSubtract, "year")
            .subtract(remainingMonths, "months");
          setNextStartDateModel(newStartDate.toDate());
          setnextEndDateModel(startDateOnee.toDate());
        }
      }
    }
  }, [startDateModel, endDateModel]); */

  function monthDiff(dateFrom, dateTo) {
    // Convert dayjs objects to native Date objects
    const fromDate = dateFrom instanceof dayjs ? dateFrom.toDate() : dateFrom;
    const toDate = dateTo instanceof dayjs ? dateTo.toDate() : dateTo;

    return (
      toDate.getMonth() -
      fromDate.getMonth() +
      12 * (toDate.getFullYear() - fromDate.getFullYear())
    );
  }

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorBulk(null);
  };
  const handleSorted = (arr, ele) => {
    if (isSorted === "asc") {
      const sortedArr = arr.sort((a, b) => a[ele].localeCompare(b[ele]));
      return sortedArr;
    } else if (isSorted === "desc") {
      const sortedArr = arr.sort((a, b) => b[ele].localeCompare(a[ele]));
      return sortedArr;
    } else {
      return arr;
    }
  };

  const handleClickMenu = (event) => {
    setAnchorBulk(event.currentTarget);
  };

  const handleExpandPanel = (event, newExpanded, panel) => {
    const _expandedPanels = [...expandedPanels];

    if (newExpanded) {
      _expandedPanels.push(panel);
    } else {
      const index = _expandedPanels.findIndex((item) => item === panel);
      if (index > -1) {
        _expandedPanels.splice(index, 1);
      }
    }
    let uniqueArray = [...new Set(_expandedPanels)];
    setExpandedPanels(uniqueArray);
  };

  const resetStates = () => {
    setModelLocations([defaultLocation]);
    setSelectedGroupsModel([]);
    setSentimentValueModel(null);
    setAutoSelect(false);
    setLanguageModel("");
    setRangeModel("custom");
    setStartDateRangeScheduleModel(startDate);
    setEndDateRangeScheduleModel(endDate);
    setSelectAllGroups(false);
    setSelectAllFeatures(false);

    // resetHandler();
  };

  const handleChangeRangeModel = (e) => {
    const value = e;
    setRangeModel(value);

    const today = new Date();
    let date = dayjs(today);
    let oneDaysBefore = date.subtract(1, "day").endOf("day");
    let oneDaysBeforeDate = oneDaysBefore.toDate();

    if (today !== null && today !== "") {
      if (value === "Yesterday") {
        let oneDaysBefore = date.subtract(1, "day");
        let oneDaysBeforeDateStart = oneDaysBefore.startOf("day").toDate();
        let oneDaysBeforeDateEnd = oneDaysBefore.endOf("day").toDate();

        setEndDateRangeScheduleModel(oneDaysBeforeDateEnd);
        setStartDateRangeScheduleModel(oneDaysBeforeDateStart);
      } else if (value === "Today") {
        let todayDayEnd = date.endOf("day");
        let oneDaysBefore = date.startOf("day");
        let oneDaysBeforeDate = oneDaysBefore.startOf("day").toDate();
        setEndDateRangeScheduleModel(todayDayEnd);
        setStartDateRangeScheduleModel(oneDaysBeforeDate);
      } else if (value === "2days") {
        let twoDaysBefore = date.subtract(2, "day");
        let twoDaysBeforeDate = twoDaysBefore.startOf("day").toDate();
        setEndDateRangeScheduleModel(oneDaysBeforeDate);
        setStartDateRangeScheduleModel(twoDaysBeforeDate);
      } else if (value === "7days") {
        let sevenDaysBefore = date.subtract(7, "day");
        let sevenDaysBeforeDate = sevenDaysBefore.startOf("day").toDate();
        setEndDateRangeScheduleModel(oneDaysBeforeDate);
        setStartDateRangeScheduleModel(sevenDaysBeforeDate);
      } else if (value === "week") {
        let weekBeforeSelectedDate = date.subtract(7, "day");
        let previousMonday = weekBeforeSelectedDate.subtract(
          weekBeforeSelectedDate.day() - 1,
          "day"
        );
        let followingSunday = previousMonday.add(6, "day");
        setEndDateRangeScheduleModel(followingSunday.endOf("day").toDate());
        setStartDateRangeScheduleModel(previousMonday.startOf("day").toDate());
      } else if (value === "month") {
        let monthBeforeSelectedDate = date.subtract(1, "month");
        let startOfMonthBefore = monthBeforeSelectedDate.startOf("month");
        let endOfMonthBefore = monthBeforeSelectedDate.endOf("month");
        setEndDateRangeScheduleModel(endOfMonthBefore.toDate());
        setStartDateRangeScheduleModel(
          startOfMonthBefore.startOf("day").toDate()
        );
      } else if (value === "14days") {
        let fourteenDaysBefore = date.subtract(14, "day");
        let fourteenDaysBeforeDate = fourteenDaysBefore.startOf("day").toDate();
        setEndDateRangeScheduleModel(oneDaysBeforeDate);
        setStartDateRangeScheduleModel(fourteenDaysBeforeDate);
      } else if (value === "30days") {
        let oneMonthBefore = date.subtract(30, "day");
        let oneMonthBeforeDate = oneMonthBefore.startOf("day").toDate();
        setEndDateRangeScheduleModel(oneDaysBeforeDate);
        setStartDateRangeScheduleModel(oneMonthBeforeDate);
      } else if (value === "60days") {
        let sixtyDaysBefore = date.subtract(60, "day");
        let sixtyDaysBeforeDate = sixtyDaysBefore.startOf("day").toDate();

        setEndDateRangeScheduleModel(oneDaysBeforeDate);
        setStartDateRangeScheduleModel(sixtyDaysBeforeDate);
      } else if (value === "90days") {
        let ninetyDaysBefore = date.subtract(90, "day");
        let ninetyDaysBeforeDate = ninetyDaysBefore.startOf("day").toDate();

        setEndDateRangeScheduleModel(oneDaysBeforeDate);
        setStartDateRangeScheduleModel(ninetyDaysBeforeDate);
      } else if (value === "6months") {
        let sixMonthsBefore = date.subtract(6, "month");
        let sixMonthsBeforeDate = sixMonthsBefore.startOf("month").toDate();
        setStartDateRangeScheduleModel(sixMonthsBeforeDate);

        let monthBeforeSelectedDate = date.subtract(1, "month");
        let startOfMonthBefore = monthBeforeSelectedDate.startOf("month");
        let endOfMonthBefore = monthBeforeSelectedDate.endOf("month");
        setEndDateRangeScheduleModel(endOfMonthBefore.toDate());
      } else if (value === "12months") {
        let oneYearBefore = date.subtract(12, "month");
        let oneYearBeforeDate = oneYearBefore.startOf("month").toDate();

        let monthBeforeSelectedDate = date.subtract(1, "month");
        let startOfMonthBefore = monthBeforeSelectedDate.startOf("month");
        let endOfMonthBefore = monthBeforeSelectedDate.endOf("month");
        setEndDateRangeScheduleModel(endOfMonthBefore.toDate());
        setStartDateRangeScheduleModel(oneYearBeforeDate);
      } else if (value === "custom") {
        setEndDateRangeScheduleModel(endDate);

        setStartDateRangeScheduleModel(startDate);
      }
    }
  };

  const handleSubmitFilters = () => {
    setLoading(true);

    handleChangeStartDate(startDateRangeScheduleModel);
    handleChangeEndDate(endDateRangeScheduleModel);
    setScheduleSentiments(sentimentValueModel);
    setLanguage(languageModel);
    setDateRangeTimePeriod(rangeModel);
    handleDateRangChange(
      rangeModel,
      true,
      startDateRangeScheduleModel,
      endDateRangeScheduleModel
    );
    const filteredLocations = modellocations?.filter(
      (item) => item?.statusOfSentimentalAnalysis === "done"
    );
    setLocations(filteredLocations);
    setSlectedGroups(selectedGroupsModel);

    setTimeout(() => {
      setLoading(true);
      handleCloseModalFilter(true);
    }, 2000);
  };

  function handleDisplayDot(countriesArr, locationsArr) {
    let countriesLocations = countriesArr?.locationsArray;
    const ids1 = new Set(countriesLocations.map((obj) => obj.id));

    for (let obj of locationsArr) {
      if (ids1.has(obj.id)) {
        return true;
      }
    }
    return false;
  }

  function filterArrayById(inputArray, targetId) {
    return inputArray.filter((item) =>
      item.groups.some((group) => group.locationId === targetId)
    );
  }
  const handleChangeGroupsModel = (value, autoSelectValue) => {
    setSelectedGroupsModel(value);

    if (autoSelectValue) {
      let newLocations = [...modellocations];
      const results = oldGroupsModel.filter(
        ({ name: id1 }) => !value.some(({ name: id2 }) => id2 === id1)
      );

      if (value?.length > 0) {
        value?.map((group) => {
          group?.groups?.map((groupItem) => {
            allLocations?.map((location) => {
              if (groupItem?.locationId === location?.id) {
                newLocations?.push(location);
              } else {
                // setSelectAll(false);
                results?.map((group) => {
                  group?.groups?.map((groupItem) => {
                    modellocations?.map((location) => {
                      const filteredArray = filterArrayById(
                        value,
                        location?.id
                      );
                      if (
                        groupItem?.locationId === location?.id &&
                        filteredArray?.length === 0
                      ) {
                        newLocations = newLocations?.filter(
                          (item) => item?.id !== location?.id
                        );
                      }
                    });
                  });
                });
              }
            });
          });
        });
      } else {
        results?.map((group) => {
          group?.groups?.map((groupItem) => {
            modellocations?.map((location) => {
              if (groupItem?.locationId === location?.id) {
                newLocations = newLocations?.filter(
                  (item) => item?.id !== location?.id
                );
              }
            });
          });
        });
      }

      const uniqueData = removeDuplicates(newLocations);

      setModelLocations(uniqueData);
    }

    setOldGroupsModel(value);
  };
  function removeDuplicates(arr) {
    const uniqueIds = new Set();
    return arr.filter((obj) => {
      if (!uniqueIds.has(obj.id)) {
        uniqueIds.add(obj.id);
        return true;
      }
      return false;
    });
  }
  function checkGroupsExistence(groups, arr) {
    return groups.every((group) =>
      arr.some((elem) => elem.id === group.locationId)
    );
  }

  const handleChangeGroupsForLocationsModel = (locations) => {
    if (modellocations?.length > 0 || selectedGroupsModel?.length > 0) {
      const filteredArray2 = selectedGroupsModel?.filter((item) =>
        item.groups ? checkGroupsExistence(item.groups, locations) : true
      );

      setSelectedGroupsModel(filteredArray2 || []); // Make sure filteredArray2 has a value or assign an empty array if it's undefined/null
      // setLocationError(false);
    } else {
      //  setSelectAllGroups(false);
      // /  setLocationError(true);
      setSelectedGroupsModel([]);
    }
  };

  const handleChangeLocationModel = (loc) => {
    setModelLocations(loc);
  };

  const handleChangeStartDateModel = (e) => {
    setStartDateModel(e);
  };

  const handleChangeEndDateModel = (e) => {
    setEndDateModel(e);
  };

  const handleChangeLanguageModel = (value) => {
    setLanguageModel(value);
  };
  const handleChangeSentimentModel = (value) => {
    setSentimentValueModel(value);
  };
  const handleExpandAllPanels = () => {
    const arr = [...expandedPanels];
    countries?.map((item) => arr.push(item?.countryName));
    const uniqueArray = [...new Set(arr)];
    setExpandedPanels(uniqueArray);

    setExpandAllPanels(false);
  };

  const handleCollapseAllPanelsPanels = () => {
    const filtered = expandedPanels?.filter((item) => item === "groups");
    setExpandedPanels(filtered);
    setExpandAllPanels(true);
  };
  const handleChangeSelectAllLocations = (e) => {
    setSelectAllFeatures(e.target.checked);
    if (e.target.checked) {
      const filteredLocations = allLocations?.filter(
        (item) => item?.statusOfSentimentalAnalysis === "done"
      );
      setModelLocations(filteredLocations);
      handleExpandAllPanels();
    } else {
      setModelLocations([]);
    }
  };
  const handleChangeAllCountryLocations = (e, locationsArr, countryName) => {
    if (e.target.checked) {
      let arr = [...modellocations];
      let mergedArr = arr.concat(locationsArr);
      const filteredLocations = mergedArr?.filter(
        (item) => item?.statusOfSentimentalAnalysis === "done"
      );
      const uniqueData = removeDuplicates(filteredLocations);
      setModelLocations(uniqueData);
    } else {
      const filtered = modellocations?.filter(
        (item) => item?.countryCode !== countryName
      );
      setModelLocations(filtered);
    }
  };

  const handleCheckForAllLocations = (countryLocations, selectedLocations) => {
    const array2IdSet = new Set(selectedLocations.map((obj) => obj.id));
    return countryLocations.every((obj) => array2IdSet.has(obj.id));
  };

  const handleChangeAutoSelect = (e) => {
    setAutoSelect(e.target.checked);

    if (e.target.checked) {
      if (selectedGroupsModel?.length > 0) {
        handleChangeGroupsModel(selectedGroupsModel, true);
      }
    } else {
      if (selectedGroupsModel?.length > 0) {
        const mergedGroups = mergeGroups(selectedGroupsModel);

        const filteredArray = removeMatchingObjects(
          modellocations,
          mergedGroups
        );
        setModelLocations(filteredArray);
      }
    }
  };

  function mergeGroups(mainArray) {
    return mainArray.reduce((accumulator, currentObject) => {
      return accumulator.concat(currentObject.groups);
    }, []);
  }

  function removeMatchingObjects(array, groups) {
    const locationIdsSet = new Set(groups.map((group) => group.locationId));
    return array.filter((obj) => !locationIdsSet.has(obj.id));
  }

  const handleChangeRangeEndDateScheduleModel = (e) => {
    setEndDateRangeScheduleModel(e);
  };
  const handleChangeRangeStartDateScheduleModel = (e) => {
    setStartDateRangeScheduleModel(e);
  };

  const handleNavigationToGroups = () => {
    navigate("/user/accounts-overview", {
      state: { tabIndex: 3, page: 0 },
    });
  };
  const handleSelectAllGroups = (e) => {
    setSelectAllGroups(e.target.checked);
    if (e.target.checked) {
      let arr = [];
      allGroups?.rows?.map((item) => {
        if (isSentimentalAnalysisDone(item?.groups)) {
          arr.push(item);
        }
      });
      handleChangeGroupsModel(arr, autoSelect);
      expandedPanels?.push("groups");
    } else {
      handleChangeGroupsModel([], autoSelect);
    }
  };
  return (
    <Modal
      open={openModalFilter}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Grid container>
        <Grid
          item
          sx={{
            height: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box className={classes.styleMainModelContainer}>
            <Box
              sx={{
                pb: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography className={classes.mainContainerHeading}>
                {t("Filters")}
              </Typography>

              <IconButton
                autoFocus
                onClick={handleCloseModalFilter}
                className="delete_button"
                sx={{ paddingTop: "0px" }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Divider />
            <Box className={classes.contentContainer}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <Box sx={{ display: "flex", gap: "10px" }}>
                  <CommonButton
                    type="submit"
                    isLoading={false}
                    disabled={false}
                    onSubmit={() => setSection("locations")}
                    label={t("Locations")}
                    leftMargin={true}
                    customHeight={true}
                    displayWhite={section === "locations" ? "false" : "true"}
                  />
                  <CommonButton
                    type="submit"
                    isLoading={false}
                    disabled={false}
                    onSubmit={() => setSection("others")}
                    label={t("others")}
                    leftMargin={true}
                    customHeight={true}
                    displayWhite={section === "others" ? "false" : "true"}
                  />
                </Box>
                <Box>
                  {section === "locations" && (
                    <>
                      <CommonButton
                        type="submit"
                        isLoading={false}
                        disabled={false}
                        onSubmit={handleClickMenu}
                        label={
                          isSorted === "asc"
                            ? t("sortA-Z")
                            : isSorted === "desc"
                            ? t("sortZ-A")
                            : t("Sort_By")
                        }
                        icon={<KeyboardArrowDownIcon />}
                        leftMargin={true}
                        customHeight={true}
                        displayWhite={"true"}
                        iconLocation={true}
                        aria-owns={anchorBulk ? "simple-menu" : undefined}
                        aria-haspopup="true"
                      />
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorBulk}
                        open={Boolean(anchorBulk)}
                        onClose={handleClose}
                        PaperProps={{
                          sx: {
                            background: "#EBEBEC",
                          },
                        }}
                      >
                        <MenuItem
                          sx={{
                            color: "#1B2430",
                            fontSize: "14px",
                            lineHeight: "20px",
                            cursor: "pointer",
                            "&:hover": {
                              background: "#DBDBDC",
                            },
                          }}
                          onClick={(e) => {
                            setIsSorted("asc");
                            handleClose();
                          }}
                        >
                          {t("sortA-Z")}
                        </MenuItem>
                        <MenuItem
                          sx={{
                            color: "#1B2430",
                            fontSize: "14px",
                            lineHeight: "20px",
                            cursor: "pointer",
                            "&:hover": {
                              background: "#DBDBDC",
                            },
                          }}
                          onClick={(e) => {
                            setIsSorted("desc");
                            handleClose();
                          }}
                        >
                          {t("sortZ-A")}
                        </MenuItem>
                      </Menu>
                    </>
                  )}
                </Box>
              </Box>

              {section === "locations" && (
                <>
                  <Box>
                    <Collapsible
                      title={t("groups_label")}
                      handleChange={handleExpandPanel}
                      expanded={expandedPanels.includes("groups")}
                      id={"groups"}
                      displayGroupSelectAll={true}
                      handleSelectAllGroups={handleSelectAllGroups}
                      selectedGroupsModel={selectedGroupsModel}
                      selectAllGroups={selectAllGroups}
                      countryNameStyling={selectedGroupsModel?.length > 0}
                      ComponentToRender={
                        <Grid container sx={{ gap: "10px" }}>
                          {allGroups !== null && allGroups?.rows?.length > 0 ? (
                            handleSorted(allGroups?.rows, "name")?.map((item) =>
                              isSentimentalAnalysisDone(item?.groups) ? (
                                <Item
                                  onClick={() => ""}
                                  sx={{
                                    padding: "7px 8px 7px 8px",
                                    gap: "4px",
                                    border: selectedGroupsModel?.find(
                                      (group) => group?.id === item?.id
                                    )
                                      ? "1px solid #06BDFF"
                                      : "1px solid #EBEBEC",
                                    borderRadius: "800px",
                                  }}
                                >
                                  <Checkbox
                                    checked={
                                      selectedGroupsModel?.length > 0 &&
                                      selectedGroupsModel?.find(
                                        (group) => group?.id === item?.id
                                      ) !== undefined
                                    }
                                    onChange={(e) => {
                                      let arr = [...selectedGroupsModel];
                                      if (e.target.checked) {
                                        arr.push(item);
                                        handleChangeGroupsModel(
                                          arr,
                                          autoSelect
                                        );
                                      } else {
                                        const filtered = arr.filter(
                                          (group) => group?.id !== item?.id
                                        );
                                        handleChangeGroupsModel(
                                          filtered,
                                          autoSelect
                                        );
                                      }
                                    }}
                                    size="small"
                                    sx={{
                                      paddingLeft: "2px",
                                      paddingRight: "2px",
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight: "400",
                                      lineHeight: "18px",
                                      color: "#1B2430",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {item.name}
                                  </Typography>
                                </Item>
                              ) : (
                                <BootstrapTooltip
                                  title={t("groups_disabled_tooltipText")}
                                >
                                  <Item
                                    onClick={() => ""}
                                    sx={{
                                      padding: "7px 8px 7px 8px",
                                      gap: "4px",
                                      border: "none",
                                      borderRadius: "800px",
                                      background: "#F0F0F0 !important",
                                    }}
                                  >
                                    <Checkbox
                                      checked={
                                        selectedGroupsModel?.length > 0 &&
                                        selectedGroupsModel?.find(
                                          (group) => group?.id === item?.id
                                        )
                                      }
                                      disabled={true}
                                      onChange={(e) => {
                                        let arr = [...selectedGroupsModel];
                                        if (e.target.checked) {
                                          arr.push(item);
                                          handleChangeGroupsModel(
                                            arr,
                                            autoSelect
                                          );
                                        } else {
                                          const filtered = arr.filter(
                                            (group) => group?.id !== item?.id
                                          );
                                          handleChangeGroupsModel(
                                            filtered,
                                            autoSelect
                                          );
                                        }
                                      }}
                                      size="small"
                                      sx={{
                                        paddingLeft: "2px",
                                        paddingRight: "2px",
                                      }}
                                    />
                                    <Typography
                                      sx={{
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        lineHeight: "18px",
                                        color: "gray !important",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {item.name}
                                    </Typography>
                                  </Item>
                                </BootstrapTooltip>
                              )
                            )
                          ) : (
                            <Grid
                              container
                              sx={{
                                height: "200px",
                                justifyContent: "center",
                                textAlign: "center",
                                alignItems: "center",
                              }}
                            >
                              <Grid item sm={8} md={8} lg={8}>
                                <Typography
                                  sx={{
                                    lineHeight: "28px",
                                    fontWeight: 700,
                                    fontSize: "20px",
                                    color: "#1b2430",
                                    marginTop: "30px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  {t("No_Groups_Found")}
                                </Typography>
                                <Typography
                                  sx={{
                                    lineHeight: "24px",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    color: "#1B2430",

                                    marginBottom: "15px",
                                  }}
                                >
                                  {t("create_groups_text")}
                                </Typography>
                                {locationAddPermission &&
                                locationViewPermission ? (
                                  <CommonButton
                                    onSubmit={handleNavigationToGroups}
                                    customHeight={true}
                                    label={t("create_groups")}
                                    icon={<AddIcon sx={{ color: "#FFFF" }} />}
                                  />
                                ) : (
                                  <BootstrapTooltip
                                    title={t("authorized_access")}
                                  >
                                    <span>
                                      <CommonButton
                                        disabled={true}
                                        onSubmit={handleNavigationToGroups}
                                        customHeight={true}
                                        label={t("create_groups")}
                                        icon={
                                          <AddIcon sx={{ color: "#FFFF" }} />
                                        }
                                      />
                                    </span>
                                  </BootstrapTooltip>
                                )}
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      }
                    />
                  </Box>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      sx={{ display: "flex" }}
                    >
                      <Checkbox
                        checked={autoSelect}
                        onChange={(e) => {
                          handleChangeAutoSelect(e);

                          //  handleChangeLocationModel(arr);
                          //  handleChangeGroupsModel(arr, e.target.checked);
                        }}
                        size="small"
                        sx={{ paddingRight: "3px", paddingLeft: "0px" }}
                      />
                      <Typography sx={{ fontSize: "12px", marginTop: "10px" }}>
                        {t("auto-select-checkbox-group")}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={{
                      padding: "8px",
                      border: "1px solid #EBEBEC",
                      borderRadius: "8px",
                    }}
                  >
                    <Grid item xs={12} sm={12} md={12} lg={12} mb={2}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{ fontWeight: 600, fontSize: "1.125rem" }}
                        >
                          {t("Locations")}
                        </Typography>

                        <Box>
                          <SmallCheckbox
                            name="selectAll"
                            color="primary"
                            checked={selectAllFeatures}
                            // disabled={defaultRole}
                            onChange={(e) => handleChangeSelectAllLocations(e)}
                            sx={{ marginRight: "4px" }}
                          />
                          {t("All_locationss")}
                          {expandAllPanels ? (
                            <IconButton onClick={handleExpandAllPanels}>
                              <ExpandMoreIcon />
                            </IconButton>
                          ) : (
                            <IconButton onClick={handleCollapseAllPanelsPanels}>
                              <ExpandLessIcon />
                            </IconButton>
                          )}
                        </Box>
                      </Box>
                    </Grid>

                    <Grid container sx={{ gap: "10px" }}>
                      {countries?.length > 0 &&
                        handleSorted(countries, "countryName")?.map((item) => (
                          <Grid item xs={12} sm={12} md={12} lg={12}>
                            {" "}
                            <Collapsible
                              title={item?.countryName}
                              handleChange={handleExpandPanel}
                              expanded={expandedPanels.includes(
                                item?.countryName
                              )}
                              id={item?.countryName}
                              countryNameStyling={handleDisplayDot(
                                item,
                                modellocations
                              )}
                              expandedPanels={expandedPanels}
                              setExpandedPanels={setExpandedPanels}
                              displaySelectAll={true}
                              itemData={item}
                              handleCheckForAllLocations={
                                handleCheckForAllLocations
                              }
                              countriesArr={item}
                              handleChangeAllCountryLocations={
                                handleChangeAllCountryLocations
                              }
                              modellocations={modellocations}
                              ComponentToRender={
                                <Grid container sx={{ gap: "10px" }}>
                                  {item?.locationsArray?.length > 0 &&
                                    handleSorted(
                                      item?.locationsArray,
                                      "internalName"
                                    )?.map((itemTwo) => (
                                      <Item
                                        onClick={() => ""}
                                        style={{
                                          padding: "12px 8px 12px 8px",
                                          gap: "4px",
                                          border:
                                            itemTwo?.statusOfSentimentalAnalysis !==
                                            "done"
                                              ? "none"
                                              : modellocations?.find(
                                                  (item) =>
                                                    item?.id === itemTwo?.id
                                                )
                                              ? "1px solid #06BDFF"
                                              : "1px solid #BBBDC1",
                                          borderRadius: "800px",
                                          background:
                                            itemTwo?.statusOfSentimentalAnalysis !==
                                            "done"
                                              ? "#F0F0F0"
                                              : modellocations?.find(
                                                  (item) =>
                                                    item?.id === itemTwo?.id
                                                )
                                              ? "#FFF"
                                              : "#FFF",

                                          //  height: "45px",
                                        }}
                                      >
                                        <Checkbox
                                          checked={
                                            modellocations?.find(
                                              (loc) => loc?.id === itemTwo?.id
                                            ) !== undefined
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => {
                                            let arr = [...modellocations];
                                            if (e.target.checked) {
                                              arr.push(itemTwo);
                                              handleChangeLocationModel(arr);
                                              if (autoSelect) {
                                                handleChangeGroupsForLocationsModel(
                                                  arr
                                                );
                                              }
                                            } else {
                                              const filtered = arr.filter(
                                                (loc) => loc?.id !== itemTwo?.id
                                              );
                                              handleChangeLocationModel(
                                                filtered
                                              );
                                              if (autoSelect) {
                                                handleChangeGroupsForLocationsModel(
                                                  filtered
                                                );
                                              }
                                            }
                                          }}
                                          disabled={
                                            itemTwo?.statusOfSentimentalAnalysis !==
                                            "done"
                                          }
                                          size="small"
                                          sx={{
                                            paddingLeft: "2px",
                                            paddingRight: "2px",
                                          }}
                                        />

                                        <Typography
                                          sx={{
                                            fontSize: "14px",
                                            fontWeight: "400",
                                            lineHeight: "18px",
                                            color:
                                              itemTwo?.statusOfSentimentalAnalysis !==
                                              "done"
                                                ? "gray !important"
                                                : modellocations?.find(
                                                    (item) =>
                                                      item?.id === itemTwo?.id
                                                  )
                                                ? "#1B2430"
                                                : "#1B2430",
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {itemTwo.internalName +
                                            (itemTwo?.city !== null &&
                                              itemTwo?.city !== "" &&
                                              " " + "(" + itemTwo?.city + ")")}
                                        </Typography>
                                        <span
                                          style={{
                                            marginLeft: "10px",
                                            color:
                                              itemTwo?.statusOfSentimentalAnalysis ===
                                              "done"
                                                ? "#13CF8F"
                                                : itemTwo?.reviewFoundStatus ==
                                                  false
                                                ? "#FC3652"
                                                : itemTwo?.statusOfSentimentalAnalysis ===
                                                  "requested"
                                                ? "#F86F35"
                                                : itemTwo?.statusOfSentimentalAnalysis ===
                                                  "inProgress"
                                                ? "#FC3652"
                                                : itemTwo?.reviewFoundStatus ===
                                                    true &&
                                                  itemTwo?.statusOfSentimentalAnalysis ===
                                                    "pending"
                                                ? "#F8A92B"
                                                : "",
                                          }}
                                        >
                                          {itemTwo?.statusOfSentimentalAnalysis ==
                                          "done"
                                            ? "• " + `${t("Done")}`
                                            : ""}
                                          {itemTwo?.reviewFoundStatus === false
                                            ? "• " + `${t("No_reviews")}`
                                            : ""}
                                          {itemTwo?.statusOfSentimentalAnalysis ==
                                          "requested"
                                            ? "• " + `${t("requested_state")}`
                                            : ""}
                                          {itemTwo?.statusOfSentimentalAnalysis ==
                                          "inProgress"
                                            ? "• " + `${t("inProgress")}`
                                            : ""}
                                          {itemTwo?.reviewFoundStatus ===
                                            true &&
                                          itemTwo?.statusOfSentimentalAnalysis ==
                                            "pending"
                                            ? "• " + `${t("Pending")}`
                                            : ""}
                                        </span>
                                      </Item>
                                    ))}
                                </Grid>
                              }
                            />
                          </Grid>
                        ))}
                    </Grid>
                  </Grid>
                </>
              )}

              {section === "others" && (
                <>
                  <Collapsible
                    title={t("Datee")}
                    handleChange={handleExpandPanel}
                    expanded={expandedPanels.includes("Date")}
                    id={"Date"}
                    ComponentToRender={
                      <Grid container sx={{ gap: "10px" }}>
                        {timePeriod.map((item, i) => (
                          <Item
                            key={i}
                            sx={{
                              border:
                                rangeModel === item.value
                                  ? "1px solid #06BDFF"
                                  : "1px solid #EBEBEC",
                            }}
                            onClick={() => {
                              handleChangeRangeModel(item.value);
                            }}
                          >
                            <Checkbox
                              checked={rangeModel === item.value ? true : false}
                              size="small"
                            />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "#1B2430",
                              }}
                            >
                              {t(item.name)}
                            </Typography>
                          </Item>
                        ))}
                        {rangeModel === "custom" && (
                          <Grid
                            container
                            spacing={2}
                            sx={{ paddingLeft: "8px", paddingRight: "8px" }}
                          >
                            {/* <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Typography className={classes.fieldLabel}>
                        {t("Fromm")}
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          disableFuture
                          placeholder={t("From")}
                          className={classes.whiteBackground}
                          value={dayjs(startDateRangeSchedule)}
                          format="DD/MM/YYYY"
                          minDate={dayjs("2005-01-01")}
                          maxDate={dayjs().endOf("day")}
                          onChange={(e) => {
                            setStartDateRangeSchedule(e);
                          }}
                          renderInput={(params) => (
                            <TextField
                              autoComplete="off"
                              fullWidth
                              {...params}
                              sx={{ padding: "8px", background: "#FFFF" }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <Typography className={classes.fieldLabel}>
                        {t("Too")}
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          disableFuture
                          className={classes.whiteBackground}
                          value={dayjs(endDateRangeSchedule)}
                          format="DD/MM/YYYY"
                          minDate={dayjs("2005-01-01")}
                          maxDate={dayjs().endOf("day")}
                          onChange={(e) => {
                            setEndDateRangeSchedule(e);

                            //   setEndDate(e);
                          }}
                          placeholder={t("To")}
                          renderInput={(params) => (
                            <TextField
                              autoComplete="off"
                              fullWidth
                              {...params}
                              //  error={dateRequired}
                              sx={{ padding: "8px", background: "#FFFF" }}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid> */}

                            <DatePickerComponent
                              handleChangeStartDate={
                                handleChangeRangeStartDateScheduleModel
                              }
                              handleChangeEndDate={
                                handleChangeRangeEndDateScheduleModel
                              }
                              startDate={
                                startDateRangeScheduleModel !== null
                                  ? startDateRangeScheduleModel
                                  : null
                              }
                              endDate={
                                endDateRangeScheduleModel !== null
                                  ? endDateRangeScheduleModel
                                  : null
                              }
                              dateRange={dateRange}
                              setDateRange={setDateRange}
                              fromFilters={true}
                              rangeValue={"between"}
                              removePadding={true}
                            />
                          </Grid>
                        )}
                      </Grid>
                    }
                  />

                  <Collapsible
                    title={t("Language_review")}
                    handleChange={handleExpandPanel}
                    expanded={expandedPanels.includes("Language")}
                    id={"Language"}
                    countryNameStyling={languageModel !== ""}
                    ComponentToRender={
                      <Grid container sx={{ gap: "10px" }}>
                        {languagesData.map((item) => (
                          <Item
                            sx={{
                              border:
                                languageModel?.language === item.language
                                  ? "1px solid #06BDFF"
                                  : "1px solid #EBEBEC",
                            }}
                            onClick={() => {}}
                          >
                            <Checkbox
                              checked={
                                languageModel?.language === item.language
                              }
                              onClick={(e) => {
                                if (e.target.checked) {
                                  handleChangeLanguageModel(item);
                                } else {
                                  handleChangeLanguageModel("");
                                }
                              }}
                              size="small"
                            />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "#1B2430",
                              }}
                            >
                              {t(item.language)}
                            </Typography>
                          </Item>
                        ))}
                      </Grid>
                    }
                  />
                  <Collapsible
                    title={t("Sentiment")}
                    handleChange={handleExpandPanel}
                    expanded={expandedPanels.includes("Sentiment")}
                    id={"Sentiment"}
                    countryNameStyling={
                      sentimentValueModel !== null && sentimentValueModel !== ""
                    }
                    ComponentToRender={
                      <Grid container sx={{ gap: "10px" }}>
                        {sentimentsValues.map((item) => (
                          <Item
                            sx={{
                              border:
                                sentimentValueModel?.label === item?.label
                                  ? "1px solid #06BDFF"
                                  : "1px solid #EBEBEC",
                            }}
                            /*   onClick={() => {
                              handleChangeSentimentModel(item);
                            }} */
                          >
                            <Checkbox
                              checked={
                                sentimentValueModel?.label === item?.label
                              }
                              onClick={(e) => {
                                if (e.target.checked) {
                                  handleChangeSentimentModel(item);
                                } else {
                                  handleChangeSentimentModel("");
                                }
                              }}
                              size="small"
                            />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "#1B2430",
                              }}
                            >
                              {t(item.label)}
                            </Typography>
                          </Item>
                        ))}
                      </Grid>
                    }
                  />
                </>
              )}
            </Box>
            <Divider />

            <Grid container sx={{ paddingTop: "10px", paddingBottom: "16px" }}>
              <Grid item md={6}></Grid>
              <Grid item md={6}>
                <Box
                  sx={{
                    justifyContent: "flex",
                    float: "right",
                  }}
                >
                  <CommonButton
                    onSubmit={resetStates}
                    label={t("Clear_Filters")}
                    leftMargin={true}
                    customHeight={true}
                    displayWhite={"true"}
                  />
                  &nbsp;&nbsp;
                  <CommonButton
                    type="submit"
                    isLoading={loading}
                    disabled={loading}
                    onSubmit={handleSubmitFilters}
                    label={t("Ok")}
                    leftMargin={true}
                    customHeight={true}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default FilterModal;

/* openModalFilter && (
  <FilterModal
    open={openModalFilter}
    close={setOpenModalFilter}
    allGroups={allGroups}
  />
); */
